import { render, staticRenderFns } from "./CProjectForm.vue?vue&type=template&id=f25b7f02&"
import script from "./CProjectForm.vue?vue&type=script&lang=js&"
export * from "./CProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports